var render = function render(){var _vm=this,_c=_vm._self._c;return _c('App',[_c(_vm.layout,{tag:"component"}),(!_vm.loading)?_c('Main',{attrs:{"appVersion":_vm.version}}):_vm._e(),_c('LoadingArea',{attrs:{"displayContent":!_vm.loading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }